/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import NoteConstants from 'constants/NoteConstants'

const NoteActions = Marty.createActionCreators({
  createNoteForEndUserId(endUserId, note) {
    return this.app.queries.NoteQueries.createNoteForEndUserId(endUserId, note)
  },

  createNoteForCompanyId(companyId, note) {
    return this.app.queries.NoteQueries.createNoteForCompanyId(companyId, note)
  }

})

export default NoteActions



// WEBPACK FOOTER //
// ./src/scripts/actions/NoteActions.js